import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {NodeOrFunction} from "../../../util/Helpers";
import {Nav} from "react-bootstrap";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";

const MultiFormContext = React.createContext()

export const MultiForm = ({onChange, ...props}) => {
    const [values, setValues] = useState({})

    const upsertValue = useCallback((key, value) => {
        // atomic set state
        setValues((prevState) => {
            return {
                ...prevState,
                [key]: value
            }
        })
    }, [])

    useEffect(() => {
        onChange && onChange(values)
    }, [values])

    const isValid = useMemo(() => {
        const valuesToValidate = Object.values(values)
        if (valuesToValidate.length === 0) return false
        let isValid = true;
        for (const value of valuesToValidate) {
            isValid = isValid && value.isValid
        }
        return isValid
    }, [values])

    const isDirty = useMemo(() => {
        const valuesToCheck = Object.values(values)
        if (valuesToCheck.length === 0) return false
        let isDirty = false;
        for (const value of valuesToCheck) {
            isDirty = isDirty || value.isDirty
        }
        return isDirty
    }, [values])

    return (
        <MultiFormContext.Provider value={{upsertValue, values}}>
            <NodeOrFunction values={values} isValid={isValid} isDirty={isDirty} upsertValue={upsertValue}>
                {props.children}
            </NodeOrFunction>
        </MultiFormContext.Provider>
    )
}

export function useMultiFormContext() {
    const context = React.useContext(MultiFormContext)
    if (!context) {
        throw new Error(
            `MultiForm context cannot be rendered outside the MultiForm component`,
        )
    }
    return context
}

export function MultiFormTab({dataKey, title, isRequired}) {
    const {values} = useMultiFormContext();

    const isValid = values[dataKey]?.isValid
    const isDirty = values[dataKey]?.isDirty

    return (
        <Nav.Item className={"w-100"}>
            <Nav.Link eventKey={dataKey} className={"px-0"}>
                <div
                    className={`bg-light-danger p-3 mr-3 rounded-circle svg-icon svg-icon-danger ${(isValid && !isDirty) && "d-none"}`}>
                    <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Warning-1-circle.svg")}/>
                </div>
                <div
                    className={`${title === "Address Update" && !isRequired ? "bg-light-success" : "bg-light-primary"} p-3 mr-3 rounded-circle svg-icon svg-icon-${title === "Address Update" && !isRequired ? "success" : "primary"} ${(!isValid || isDirty) && "d-none"}`}>
                    <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")}/>
                </div>
                <div>
                    {title}
                    {!isRequired && <div className={`text-${!isRequired && title === "Address Update" ? "success" : "muted"}`}>Not Required</div>}
                </div>
            </Nav.Link>
        </Nav.Item>
    );
}